// Simple i18n
const translations = {
  it: {
    appName: "Cognitive Clone",
    tagline: "Costruisci il clone cognitivo del tuo ruolo",
    // Auth
    login: "Accedi",
    register: "Registrati",
    logout: "Esci",
    email: "Email",
    password: "Password",
    name: "Nome",
    submit: "Invia",
    continue: "Continua",
    cancel: "Annulla",
    save: "Salva",
    delete: "Elimina",
    edit: "Modifica",
    back: "Indietro",
    next: "Avanti",
    loading: "Caricamento...",
    noAccount: "Non hai un account?",
    haveAccount: "Hai già un account?",
    loginTitle: "Bentornato",
    loginSubtitle: "Accedi al tuo spazio cognitivo",
    registerTitle: "Crea il tuo account",
    registerSubtitle: "Inizia a costruire il tuo clone cognitivo",
    // Dashboard
    myClones: "I miei cloni",
    sharedWithMe: "Condivisi con me",
    createClone: "Crea clone",
    noClonesYet: "Nessun clone ancora. Creane uno per iniziare.",
    noSharedClones: "Nessun clone condiviso con te.",
    answers: "risposte",
    // Setup
    setupTitle: "Configura il tuo clone",
    setupSubtitle: "Definisci il ruolo che il clone deve rappresentare",
    roleName: "Nome del ruolo",
    roleNamePh: "es. Direttore Marketing",
    industry: "Settore / Industria",
    industryPh: "es. FinTech, Healthcare...",
    responsibilities: "Responsabilità principali",
    responsibilitiesPh: "Descrivi cosa fai ogni giorno, decisioni ricorrenti, obiettivi...",
    language: "Lingua",
    avatar: "Avatar",
    createAndGenerate: "Crea e genera domande",
    // Calibration
    calibrationTitle: "Calibrazione",
    calibrationSubtitle: "Rispondi a 5 domande per calibrare il clone",
    yourAnswer: "La tua risposta",
    saveAnswer: "Salva risposta",
    question: "Domanda",
    of: "di",
    calibrationComplete: "Calibrazione completata",
    goToTraining: "Vai al training",
    goToClone: "Interroga il clone",
    regenerate: "Rigenera domande",
    // Training
    trainingTitle: "Modalità training",
    trainingSubtitle: "Domande nuove basate su lacune e scenari realistici",
    generateQuestions: "Genera domande",
    skipQuestion: "Salta",
    sessionComplete: "Sessione completata",
    // Clone mode
    cloneMode: "Modalità clone",
    askTheClone: "Chiedi al clone...",
    respondingAs: "Risposta come",
    askQuestion: "Fai una domanda",
    send: "Invia",
    thinking: "Il clone sta pensando...",
    noAnswersYet: "Il clone non ha ancora risposte. Completa prima la calibrazione.",
    // Profile panel
    profile: "Profilo",
    topicsCovered: "Argomenti coperti",
    scenarioTypes: "Tipi di scenario",
    totalAnswers: "Risposte totali",
    lastUpdate: "Ultimo aggiornamento",
    // Tabs
    setup: "Setup",
    training: "Training",
    clone: "Clone",
    share: "Condividi",
    // Share
    shareTitle: "Condividi il clone",
    shareSubtitle: "Scegli chi può interrogare questo clone",
    visibilityPrivate: "Privato (solo tu)",
    visibilitySpecific: "Utenti specifici",
    visibilityPublic: "Pubblico (chiunque col link)",
    allowedEmails: "Email autorizzate",
    allowedEmailsPh: "email@example.com, altra@example.com",
    organization: "Organizzazione (opzionale)",
    organizationPh: "es. Acme Corp",
    shareLink: "Link pubblico",
    copyLink: "Copia link",
    linkCopied: "Link copiato!",
    // Errors
    errorGeneric: "Si è verificato un errore",
    errorRequired: "Campo obbligatorio",
    errorInvalidCredentials: "Credenziali non valide",
    confirmDelete: "Sei sicuro di voler eliminare questo clone?",
    // Tags
    topic: "Argomento",
    scenarioType: "Tipo scenario",
    decisionMade: "Decisione",
    // Empty states
    startByAnswering: "Inizia rispondendo alle domande",
    // Diary
    diary: "Diario",
    diaryTitle: "Diario di oggi",
    diarySubtitle: "Racconta cosa è successo oggi e come l'hai gestito",
    diaryPlaceholder: "Oggi ho...",
    saveDiary: "Salva nel diario",
    noDiaryEntries: "Nessuna entry nel diario",
    // FAQ
    faq: "FAQ",
    faqTitle: "Domande frequenti al clone",
    faqSubtitle: "Le domande più fatte al tuo clone (anonimizzate)",
    noFaqYet: "Ancora nessuna domanda. Le FAQ appariranno qui quando qualcuno interrogherà il clone.",
    asked: "chieste",
    lastAsked: "Ultima volta",
    // Consent
    consentTitle: "Informativa sulla privacy",
    consentBody: "Utilizzando questo clone, sei consapevole che le domande che farai saranno visibili al creatore del clone. Le tue domande rimarranno comunque anonime (l'identità di chi ha chiesto non sarà rivelata).",
    consentAccept: "Ho capito, continua",
    consentDecline: "Annulla",
    // Admin
    admin: "Admin",
    adminTitle: "Dashboard Amministrativa",
    adminSubtitle: "Statistiche sito e utilizzo dei cloni",
    totalUsers: "Utenti totali",
    activeUsers7: "Attivi (7 giorni)",
    activeUsers30: "Attivi (30 giorni)",
    totalClones: "Cloni totali",
    publicClones: "Cloni pubblici",
    totalConversations: "Conversazioni totali",
    conversations7: "Conversazioni (7 giorni)",
    diaryEntries: "Entry diario",
    topClones: "Cloni più usati",
    usersTab: "Utenti",
    clonesTab: "Cloni",
    sendDailyNow: "Invia email giornaliera ora",
    dailyEmailSent: "Email inviate",
    // Password reset
    forgotPassword: "Password dimenticata?",
    forgotPasswordTitle: "Recupera password",
    forgotPasswordSubtitle: "Ti invieremo un link per reimpostare la password",
    sendResetLink: "Invia link di reset",
    resetEmailSent: "Se l'email esiste, riceverai un link per il reset.",
    resetPasswordTitle: "Nuova password",
    resetPasswordSubtitle: "Scegli una nuova password (min 6 caratteri)",
    newPassword: "Nuova password",
    confirmPassword: "Conferma password",
    passwordsDontMatch: "Le password non coincidono",
    resetSuccess: "Password aggiornata. Accedi ora.",
    // Settings
    settings: "Impostazioni",
    settingsTitle: "Impostazioni account",
    preferences: "Preferenze",
    dailyEmailEnabled: "Ricevi email giornaliera di training (18:00)",
    phoneLabel: "Telefono (recupero contatto)",
    phonePh: "+39 ...",
    saved: "Salvato",
    // Write / choice
    chooseAction: "Cosa vuoi fare?",
    writeDiary: "Scrivi nel diario",
    answerTraining: "Rispondi a domande di training",
    // Category
    workClones: "Lavoro",
    personalClones: "Svago",
    categoryWork: "Clone di lavoro",
    categoryPersonal: "Clone personale",
    categoryLabel: "Categoria",
    categoryWorkDesc: "Il tuo ruolo professionale, le decisioni sul lavoro",
    categoryPersonalDesc: "La tua vita quotidiana, abitudini e valori personali",
    // Personal setup labels (override work labels)
    yourName: "Il tuo nome",
    yourNamePh: "es. Simone",
    lifeContext: "Contesto di vita",
    lifeContextPh: "es. 32 anni, single, vivo a Milano",
    personality: "Come sei e cosa ami fare",
    personalityPh: "Descrivi le tue passioni, abitudini, valori, chi sei nella vita di tutti i giorni...",
    // Linking
    linkedClone: "Clone collegato",
    linkClone: "Collega a un altro clone",
    unlink: "Scollega",
    noLinkableClones: "Nessun clone da collegare (crea prima un clone della categoria opposta)",
    linkedWith: "Unificato con",
    unifiedClone: "Clone Unificato",
    unifiedNote: "Le risposte combinano il tuo lato professionale e personale",
    // New training UX
    oneMoreQuestion: "Un'altra domanda",
    orCustomAnswer: "Oppure scrivi la tua risposta",
    customAnswerPh: "Scrivi come avresti gestito la situazione...",
    presetOption: "Scegli un'opzione",
    todayQuestion: "La tua domanda di oggi",
    trainingDone: "Domanda completata",
    // Section headings
    switchSection: "Cambia sezione",
    // Phase 2: Avatar
    uploadPhoto: "Carica una foto",
    uploadPhotoDesc: "Trasformeremo la tua foto in un avatar cartoon con AI",
    generateAvatar: "Genera avatar",
    generatingAvatar: "Sto generando l'avatar (30-45s)...",
    removeAvatar: "Rimuovi avatar",
    avatarGenerated: "Avatar generato!",
    dragOrClick: "Trascina una foto o clicca per selezionare",
    changePhoto: "Cambia foto",
    // Phase 2: Voice
    talkToMe: "Parla con me",
    startRecording: "Inizia a parlare",
    stopRecording: "Ferma",
    recording: "Registrazione in corso...",
    transcribing: "Trascrizione in corso...",
    speaking: "Sta parlando...",
    listenAgain: "Riascolta",
    voiceConsent: "Attiva la modalità voce",
    voiceConsentBody: "Le conversazioni verranno trascritte e potranno essere salvate per far somigliare sempre di più il clone a te. Puoi disattivare il salvataggio in qualsiasi momento.",
    saveConversations: "Salva le conversazioni per il training",
    voiceEnable: "Attiva",
    micDenied: "Accesso al microfono negato",
    voiceUnavailable: "Il tuo browser non supporta la registrazione audio",
    ttsVoice: "Voce del clone",
    // Personality
    personalityLabel: "Personalità",
    personalityTitle: "Impronta di personalità",
    personalityFewData: "Servono almeno 3 risposte per calcolare l'impronta",
    // Placeholder / info
    optionalPhoto: "Opzionale · trasforma la tua foto in avatar cartoon",
  },
  en: {
    appName: "Cognitive Clone",
    tagline: "Build the cognitive clone of your role",
    login: "Sign in",
    register: "Sign up",
    logout: "Sign out",
    email: "Email",
    password: "Password",
    name: "Name",
    submit: "Submit",
    continue: "Continue",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    back: "Back",
    next: "Next",
    loading: "Loading...",
    noAccount: "No account?",
    haveAccount: "Already have an account?",
    loginTitle: "Welcome back",
    loginSubtitle: "Sign in to your cognitive space",
    registerTitle: "Create your account",
    registerSubtitle: "Start building your cognitive clone",
    myClones: "My clones",
    sharedWithMe: "Shared with me",
    createClone: "Create clone",
    noClonesYet: "No clones yet. Create one to get started.",
    noSharedClones: "No clones shared with you.",
    answers: "answers",
    setupTitle: "Configure your clone",
    setupSubtitle: "Define the role the clone should represent",
    roleName: "Role name",
    roleNamePh: "e.g. Marketing Director",
    industry: "Industry",
    industryPh: "e.g. FinTech, Healthcare...",
    responsibilities: "Main responsibilities",
    responsibilitiesPh: "Describe your daily work, recurring decisions, goals...",
    language: "Language",
    avatar: "Avatar",
    createAndGenerate: "Create & generate questions",
    calibrationTitle: "Calibration",
    calibrationSubtitle: "Answer 5 questions to calibrate the clone",
    yourAnswer: "Your answer",
    saveAnswer: "Save answer",
    question: "Question",
    of: "of",
    calibrationComplete: "Calibration complete",
    goToTraining: "Go to training",
    goToClone: "Ask the clone",
    regenerate: "Regenerate questions",
    trainingTitle: "Training mode",
    trainingSubtitle: "New questions based on gaps and realistic scenarios",
    generateQuestions: "Generate questions",
    skipQuestion: "Skip",
    sessionComplete: "Session complete",
    cloneMode: "Clone mode",
    askTheClone: "Ask the clone...",
    respondingAs: "Responding as",
    askQuestion: "Ask a question",
    send: "Send",
    thinking: "The clone is thinking...",
    noAnswersYet: "The clone has no answers yet. Complete calibration first.",
    profile: "Profile",
    topicsCovered: "Topics covered",
    scenarioTypes: "Scenario types",
    totalAnswers: "Total answers",
    lastUpdate: "Last update",
    setup: "Setup",
    training: "Training",
    clone: "Clone",
    share: "Share",
    shareTitle: "Share clone",
    shareSubtitle: "Choose who can query this clone",
    visibilityPrivate: "Private (only you)",
    visibilitySpecific: "Specific users",
    visibilityPublic: "Public (anyone with link)",
    allowedEmails: "Allowed emails",
    allowedEmailsPh: "email@example.com, other@example.com",
    organization: "Organization (optional)",
    organizationPh: "e.g. Acme Corp",
    shareLink: "Public link",
    copyLink: "Copy link",
    linkCopied: "Link copied!",
    errorGeneric: "Something went wrong",
    errorRequired: "Required field",
    errorInvalidCredentials: "Invalid credentials",
    confirmDelete: "Delete this clone?",
    topic: "Topic",
    scenarioType: "Scenario type",
    decisionMade: "Decision",
    startByAnswering: "Start by answering the questions",
  },
  es: {
    appName: "Cognitive Clone",
    tagline: "Construye el clon cognitivo de tu rol",
    login: "Iniciar sesión",
    register: "Registrarse",
    logout: "Cerrar sesión",
    email: "Email",
    password: "Contraseña",
    name: "Nombre",
    submit: "Enviar",
    continue: "Continuar",
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    back: "Atrás",
    next: "Siguiente",
    loading: "Cargando...",
    noAccount: "¿No tienes cuenta?",
    haveAccount: "¿Ya tienes cuenta?",
    loginTitle: "Bienvenido de nuevo",
    loginSubtitle: "Accede a tu espacio cognitivo",
    registerTitle: "Crea tu cuenta",
    registerSubtitle: "Empieza a construir tu clon cognitivo",
    myClones: "Mis clones",
    sharedWithMe: "Compartidos conmigo",
    createClone: "Crear clon",
    noClonesYet: "Aún no hay clones. Crea uno para empezar.",
    noSharedClones: "No hay clones compartidos contigo.",
    answers: "respuestas",
    setupTitle: "Configura tu clon",
    setupSubtitle: "Define el rol que debe representar el clon",
    roleName: "Nombre del rol",
    roleNamePh: "ej. Director de Marketing",
    industry: "Sector / Industria",
    industryPh: "ej. FinTech, Salud...",
    responsibilities: "Responsabilidades principales",
    responsibilitiesPh: "Describe tu trabajo diario, decisiones recurrentes, objetivos...",
    language: "Idioma",
    avatar: "Avatar",
    createAndGenerate: "Crear y generar preguntas",
    calibrationTitle: "Calibración",
    calibrationSubtitle: "Responde 5 preguntas para calibrar el clon",
    yourAnswer: "Tu respuesta",
    saveAnswer: "Guardar respuesta",
    question: "Pregunta",
    of: "de",
    calibrationComplete: "Calibración completada",
    goToTraining: "Ir a entrenamiento",
    goToClone: "Consultar al clon",
    regenerate: "Regenerar preguntas",
    trainingTitle: "Modo entrenamiento",
    trainingSubtitle: "Nuevas preguntas basadas en lagunas y escenarios reales",
    generateQuestions: "Generar preguntas",
    skipQuestion: "Saltar",
    sessionComplete: "Sesión completada",
    cloneMode: "Modo clon",
    askTheClone: "Pregunta al clon...",
    respondingAs: "Respondiendo como",
    askQuestion: "Haz una pregunta",
    send: "Enviar",
    thinking: "El clon está pensando...",
    noAnswersYet: "El clon aún no tiene respuestas. Completa la calibración primero.",
    profile: "Perfil",
    topicsCovered: "Temas cubiertos",
    scenarioTypes: "Tipos de escenario",
    totalAnswers: "Respuestas totales",
    lastUpdate: "Última actualización",
    setup: "Setup",
    training: "Training",
    clone: "Clon",
    share: "Compartir",
    shareTitle: "Compartir clon",
    shareSubtitle: "Elige quién puede consultar este clon",
    visibilityPrivate: "Privado (solo tú)",
    visibilitySpecific: "Usuarios específicos",
    visibilityPublic: "Público (con enlace)",
    allowedEmails: "Emails autorizados",
    allowedEmailsPh: "email@example.com, otro@example.com",
    organization: "Organización (opcional)",
    organizationPh: "ej. Acme Corp",
    shareLink: "Enlace público",
    copyLink: "Copiar enlace",
    linkCopied: "¡Enlace copiado!",
    errorGeneric: "Algo salió mal",
    errorRequired: "Campo obligatorio",
    errorInvalidCredentials: "Credenciales no válidas",
    confirmDelete: "¿Eliminar este clon?",
    topic: "Tema",
    scenarioType: "Tipo escenario",
    decisionMade: "Decisión",
    startByAnswering: "Empieza respondiendo las preguntas",
  },
  fr: {
    appName: "Cognitive Clone",
    tagline: "Construisez le clone cognitif de votre rôle",
    login: "Connexion",
    register: "Inscription",
    logout: "Déconnexion",
    email: "Email",
    password: "Mot de passe",
    name: "Nom",
    submit: "Envoyer",
    continue: "Continuer",
    cancel: "Annuler",
    save: "Enregistrer",
    delete: "Supprimer",
    edit: "Modifier",
    back: "Retour",
    next: "Suivant",
    loading: "Chargement...",
    noAccount: "Pas de compte?",
    haveAccount: "Déjà un compte?",
    loginTitle: "Bon retour",
    loginSubtitle: "Accédez à votre espace cognitif",
    registerTitle: "Créez votre compte",
    registerSubtitle: "Commencez à construire votre clone cognitif",
    myClones: "Mes clones",
    sharedWithMe: "Partagés avec moi",
    createClone: "Créer un clone",
    noClonesYet: "Aucun clone. Créez-en un pour commencer.",
    noSharedClones: "Aucun clone partagé avec vous.",
    answers: "réponses",
    setupTitle: "Configurez votre clone",
    setupSubtitle: "Définissez le rôle que le clone doit représenter",
    roleName: "Nom du rôle",
    roleNamePh: "ex. Directeur Marketing",
    industry: "Secteur",
    industryPh: "ex. FinTech, Santé...",
    responsibilities: "Responsabilités principales",
    responsibilitiesPh: "Décrivez votre quotidien, décisions récurrentes, objectifs...",
    language: "Langue",
    avatar: "Avatar",
    createAndGenerate: "Créer et générer des questions",
    calibrationTitle: "Calibration",
    calibrationSubtitle: "Répondez à 5 questions pour calibrer le clone",
    yourAnswer: "Votre réponse",
    saveAnswer: "Enregistrer la réponse",
    question: "Question",
    of: "sur",
    calibrationComplete: "Calibration terminée",
    goToTraining: "Aller à l'entraînement",
    goToClone: "Interroger le clone",
    regenerate: "Regénérer",
    trainingTitle: "Mode entraînement",
    trainingSubtitle: "Nouvelles questions basées sur les lacunes et scénarios réels",
    generateQuestions: "Générer des questions",
    skipQuestion: "Passer",
    sessionComplete: "Session terminée",
    cloneMode: "Mode clone",
    askTheClone: "Demandez au clone...",
    respondingAs: "Réponse en tant que",
    askQuestion: "Posez une question",
    send: "Envoyer",
    thinking: "Le clone réfléchit...",
    noAnswersYet: "Le clone n'a pas de réponses. Complétez la calibration d'abord.",
    profile: "Profil",
    topicsCovered: "Sujets couverts",
    scenarioTypes: "Types de scénario",
    totalAnswers: "Réponses totales",
    lastUpdate: "Dernière mise à jour",
    setup: "Setup",
    training: "Training",
    clone: "Clone",
    share: "Partager",
    shareTitle: "Partager le clone",
    shareSubtitle: "Choisissez qui peut interroger ce clone",
    visibilityPrivate: "Privé (seulement vous)",
    visibilitySpecific: "Utilisateurs spécifiques",
    visibilityPublic: "Public (avec lien)",
    allowedEmails: "Emails autorisés",
    allowedEmailsPh: "email@example.com, autre@example.com",
    organization: "Organisation (optionnel)",
    organizationPh: "ex. Acme Corp",
    shareLink: "Lien public",
    copyLink: "Copier le lien",
    linkCopied: "Lien copié!",
    errorGeneric: "Une erreur s'est produite",
    errorRequired: "Champ requis",
    errorInvalidCredentials: "Identifiants invalides",
    confirmDelete: "Supprimer ce clone?",
    topic: "Sujet",
    scenarioType: "Type de scénario",
    decisionMade: "Décision",
    startByAnswering: "Commencez par répondre aux questions",
  },
  de: {
    appName: "Cognitive Clone",
    tagline: "Baue den kognitiven Klon deiner Rolle",
    login: "Anmelden",
    register: "Registrieren",
    logout: "Abmelden",
    email: "E-Mail",
    password: "Passwort",
    name: "Name",
    submit: "Absenden",
    continue: "Weiter",
    cancel: "Abbrechen",
    save: "Speichern",
    delete: "Löschen",
    edit: "Bearbeiten",
    back: "Zurück",
    next: "Weiter",
    loading: "Laden...",
    noAccount: "Kein Konto?",
    haveAccount: "Bereits ein Konto?",
    loginTitle: "Willkommen zurück",
    loginSubtitle: "Melde dich bei deinem kognitiven Raum an",
    registerTitle: "Konto erstellen",
    registerSubtitle: "Beginne deinen kognitiven Klon zu bauen",
    myClones: "Meine Klone",
    sharedWithMe: "Mit mir geteilt",
    createClone: "Klon erstellen",
    noClonesYet: "Noch keine Klone. Erstelle einen, um zu beginnen.",
    noSharedClones: "Keine Klone mit dir geteilt.",
    answers: "Antworten",
    setupTitle: "Konfiguriere deinen Klon",
    setupSubtitle: "Definiere die Rolle, die der Klon repräsentieren soll",
    roleName: "Rollenname",
    roleNamePh: "z.B. Marketing Director",
    industry: "Branche",
    industryPh: "z.B. FinTech, Gesundheit...",
    responsibilities: "Hauptverantwortlichkeiten",
    responsibilitiesPh: "Beschreibe deinen Alltag, wiederkehrende Entscheidungen, Ziele...",
    language: "Sprache",
    avatar: "Avatar",
    createAndGenerate: "Erstellen und Fragen generieren",
    calibrationTitle: "Kalibrierung",
    calibrationSubtitle: "Beantworte 5 Fragen zur Kalibrierung",
    yourAnswer: "Deine Antwort",
    saveAnswer: "Antwort speichern",
    question: "Frage",
    of: "von",
    calibrationComplete: "Kalibrierung abgeschlossen",
    goToTraining: "Zum Training",
    goToClone: "Klon befragen",
    regenerate: "Neu generieren",
    trainingTitle: "Trainingsmodus",
    trainingSubtitle: "Neue Fragen basierend auf Lücken und realen Szenarien",
    generateQuestions: "Fragen generieren",
    skipQuestion: "Überspringen",
    sessionComplete: "Sitzung abgeschlossen",
    cloneMode: "Klon-Modus",
    askTheClone: "Frage den Klon...",
    respondingAs: "Antwort als",
    askQuestion: "Stelle eine Frage",
    send: "Senden",
    thinking: "Der Klon denkt nach...",
    noAnswersYet: "Der Klon hat noch keine Antworten. Schließe zuerst die Kalibrierung ab.",
    profile: "Profil",
    topicsCovered: "Abgedeckte Themen",
    scenarioTypes: "Szenariotypen",
    totalAnswers: "Antworten insgesamt",
    lastUpdate: "Letzte Aktualisierung",
    setup: "Setup",
    training: "Training",
    clone: "Klon",
    share: "Teilen",
    shareTitle: "Klon teilen",
    shareSubtitle: "Wähle, wer diesen Klon befragen kann",
    visibilityPrivate: "Privat (nur du)",
    visibilitySpecific: "Bestimmte Nutzer",
    visibilityPublic: "Öffentlich (jeder mit Link)",
    allowedEmails: "Erlaubte E-Mails",
    allowedEmailsPh: "email@example.com, andere@example.com",
    organization: "Organisation (optional)",
    organizationPh: "z.B. Acme Corp",
    shareLink: "Öffentlicher Link",
    copyLink: "Link kopieren",
    linkCopied: "Link kopiert!",
    errorGeneric: "Etwas ist schiefgelaufen",
    errorRequired: "Pflichtfeld",
    errorInvalidCredentials: "Ungültige Anmeldedaten",
    confirmDelete: "Diesen Klon löschen?",
    topic: "Thema",
    scenarioType: "Szenariotyp",
    decisionMade: "Entscheidung",
    startByAnswering: "Beginne mit den Fragen",
  },
};

export const LANGS = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
];

export function getLang() {
  return localStorage.getItem("lang") || "it";
}

export function setLang(code) {
  localStorage.setItem("lang", code);
  window.dispatchEvent(new Event("langchange"));
}

export function t(key, lang) {
  const code = lang || getLang();
  return translations[code]?.[key] || translations.it[key] || key;
}

export default translations;
